module.exports = __webpack_public_path__ + "img/60.d992b354.jpg";